<template>
  <div class="p-grid">
    <div class="p-col-12">
      <br />
      

      <h4>List of Linked Accounts</h4>

      <Toolbar class="p-mb-4">
        <template slot="left">
          <Button
            label="New Account"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            @click="openNew"
          />
        </template>

        <template slot="right">
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              v-model="filters['global']"
              placeholder="Global Search"
              style="margin-right: 0.5em"
              @input="updateSearch"
            />
          </span>
        </template>
      </Toolbar>
    
      <!-- LA: the tab had no list; it now shows the same linked accounts as the Customers list's
           "View MBP Branch Accounts" dialog (linkedAccountsMixin) -->
      <LinkedAccountsTable
        :accounts="linkedAccounts"
        :loading="loading"
        :removingLink="removingLink"
        :filters="filters"
        @accountClicked="editAccount"
        @removeLink="askRemoveLink"
      />

      <LinkedAccountRemoveConfirm
        :visible.sync="displayRemoveConfirm"
        :account="removeCandidate"
        @confirm="confirmRemoveLink"
      />

      <!-- Account Form -->
      <AccountForm
        :accountDialog="accountDialog"
        :reload="realodAccountDialog"
        :refresh="refreshAccountDialog"
        :accountToEdit="account"
        :customer="customer"
        :disabledArr="disabledArr"
        :requestType="accountRequestType"
        @close="accountDialog = false"
        @saved="savedAccount"
      />

    </div>
  </div>
</template>

<script>
import AccountForm from '../../universalComponents/customer/AccountForm'
import LinkedAccountsTable from '../../universalComponents/customer/LinkedAccountsTable'
import LinkedAccountRemoveConfirm from '../../universalComponents/customer/LinkedAccountRemoveConfirm'
import linkedAccountsMixin from '../../universalComponents/customer/linkedAccountsMixin'

export default {
  mixins: [linkedAccountsMixin],
  components: {
    AccountForm,
    LinkedAccountsTable,
    LinkedAccountRemoveConfirm
  },
  props: ["customer"],
  data: () => ({
    filters: {},
    // New Account keeps the tab's own save (customerGroup); editing a listed account saves as the
    // dialog does (customerMBPBranch)
    accountRequestType: undefined
  }),
  computed: {
    loading() {
      return !(this.linkedAccounts && this.linkedAccounts[0]) && this.requesting
    }
  },
  created() {
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
    this.assignedCustomerMBPbranches()
  },
  watch: {
    customer(val) {
      if (val && val.customerId) {
        if (this.accountDialog) {
          this.account.customerId = val.customerId
          this.account.mbpBranch = val.mbpBranch
          this.refreshAccountDialog++
        } else {
          this.assignedCustomerMBPbranches()
        }
      }
    }
  },
  methods: {
    editAccount(account) {
      this.accountRequestType = 'customerMBPBranch'
      this.accountClicked(account)
    },
    savedAccount() {
      this.accountDialog = false
      this.assignedCustomerMBPbranches()
    },
    openNew() {
      this.accountRequestType = undefined
      this.disabledArr = [
        'customer'
      ]
      this.account = {}
      this.account.customerId = this.customer.customerId
      this.account.mbpBranch = this.customer.mbpBranch
      this.account.mainBranch = false
      this.account.active = true
      
      this.accountDialog = true
      this.refreshAccountDialog++
      this.realodAccountDialog++
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    }
  }
}
</script>

<style>

</style>